import React, { useState } from "react";

import Connect from "./views/ConnectView.jsx";
import DisconnectCard from "./views/DisconnectView.jsx";
import MainPage from "./views/ConnectedView.jsx";
import { WebSocketManager } from "./operators/WebsocketOperator.jsx";
import { PlayerProvider, usePlayer } from "./operators/PlayerOperator.jsx";
import { RegionAudioManager } from "./operators/RegionAudioOperator.jsx";
import { SoundEffectManager } from "./operators/SoundEffectOperator.jsx";
import { RideAudioManager } from "./operators/RideaudioOperator.jsx";

function AppWrapper() {
  return (
    <PlayerProvider>
      <App />
    </PlayerProvider>
  );
}

function App() {
  const [isConnected, setIsConnected] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(false);
  const { setUserUpdate, setUserDefaultState } = usePlayer();
  const wsEndpoint = "wss://ws.movigate.co:8887/connect";

  if (isDisconnected) {
    return (
      <DisconnectCard
        title="Session closed"
        text="Connection to the server has been lost"
      />
    );
  }

  return (
    <div>
      {!isConnected ? (
        <Connect
          title="Connect!"
          text="Please press the button to connect to the web client."
          onConnect={() =>
            WebSocketManager.connect({
              endpoint: wsEndpoint,
              onConnected: (uuid, username) => {
                setIsConnected(true);
                setIsDisconnected(false);
                setUserUpdate(username, uuid);
              },
              onDisconnected: () => {
                setIsConnected(false);
                setIsDisconnected(true);
                setUserDefaultState();
                RegionAudioManager.stopRegionMusic();
              },
              onError: () => {
                setIsConnected(false);
                setIsDisconnected(true);
                setUserDefaultState();
              },
              onMessage: (data, socket) => {
                try {
                  if (data.ACTION === "CONNECTION_STATE") {
                    if (
                      data["state-code"] === 431 &&
                      data["state-text"] === "Invalid Access"
                    ) {
                      setUserDefaultState();
                      socket.close();
                    }
                  } else if (data.ACTION === "REGION_MUSIC") {
                    RegionAudioManager.handleRegionMusic(
                      data.url,
                      data.time || 0
                    );
                  } else if (data.ACTION === "SOUND_EFFECT") {
                    SoundEffectManager.handleSoundEffect(data.url);
                  } else if (data.ACTION === "STOP") {
                    RegionAudioManager.stopRegionMusic();
                  } else if (data.ACTION === "MUFFLE_EFFECT") {
                    if (data["state"] === "on") {
                      RegionAudioManager.enableMuffleEffect();
                    } else if (data["state"] === "off") {
                      RegionAudioManager.disableMuffleEffect();
                    }
                  } else if (data.ACTION === "RIDE_START") {
                    RideAudioManager.handleRideStart(
                      data.url,
                      data.speed,
                      data.relX,
                      data.relY,
                      data.relZ
                    );
                  } else if (data.ACTION === "RIDE_UPDATE") {
                    RideAudioManager.handleRideUpdate(
                      data.relX,
                      data.relY,
                      data.relZ,
                      data.yaw,
                      data.pitch,
                      data.speed
                    );
                  } else if (data.ACTION === "RIDE_STOP") {
                    RideAudioManager.handleRideStop();
                  }
                } catch (e) {
                  console.warn("Invalid message:", e, data);
                }
              },
            })
          }
        />
      ) : (
        <MainPage />
      )}
    </div>
  );
}

export default AppWrapper;
